import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import FluidImageWrapper from '../FluidImageWrapper';
import ImageFluid from '../ImageFluid';
import Text from '../Text';
import Styles from './ImageOpening.styles';

const Container = styled.div`
  ${Styles.container}
`;
const InnerWrapper = styled.div`
  ${Styles.innerWrapper}
`;
const Content = styled.div`
  ${Styles.content}
`;
const Title = styled(Text)`
  ${Styles.title}
`;
const GradientLayer = styled.div`
  ${Styles.gradientLayer}
`;

/**
 * ImageOpening component
 * @returns {JSX}
 */
const ImageOpening = ({
  title,
  content,
  image,
  className,
  alt
}) => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <Container className={className}>
            <InnerWrapper>
              <Title tag="h2" bold>{title}</Title>
              <Content dangerouslySetInnerHTML={{ __html: content }} />
            </InnerWrapper>
            <GradientLayer />
            <FluidImageWrapper>
              <ImageFluid fluid={image} alt={alt} />
            </FluidImageWrapper>
          </Container>
        </div>
      </div>
    </div>
  );
};

ImageOpening.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  image: PropTypes.object,
  className: PropTypes.string,
  alt: PropTypes.string
};

export default ImageOpening;
